import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/ProjectManagerBasic.css';

interface BasicTask {
  id: number;
  title: string;
  assignee: string;
  dueDate: string;
  completed: boolean;
}

const ProjectManagerBasic: React.FC = () => {
  const [tasks, setTasks] = useState<BasicTask[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    // Simulate API call
    setTimeout(() => {
      setTasks([
        { id: 1, title: 'Design new landing page', assignee: 'Alice', dueDate: '2024-02-15', completed: false },
        { id: 2, title: 'Fix login bug', assignee: 'Bob', dueDate: '2024-02-10', completed: true },
        { id: 3, title: 'Write project documentation', assignee: 'Carol', dueDate: '2024-02-20', completed: false },
        { id: 4, title: 'Test payment integration', assignee: 'Dave', dueDate: '2024-02-18', completed: false },
        { id: 5, title: 'Update user profile page', assignee: 'Eve', dueDate: '2024-02-12', completed: true }
      ]);
      setLoading(false);
    }, 1000);
  }, []);

  const handleToggleComplete = (taskId: number) => {
    setTasks(tasks.map(task => 
      task.id === taskId 
        ? { ...task, completed: !task.completed }
        : task
    ));
  };

  if (loading) {
    return (
      <div className="project-basic-loading">
        <p>Loading...</p>
      </div>
    );
  }

  const completedTasks = tasks.filter(task => task.completed).length;
  const totalTasks = tasks.length;

  return (
    <div className="project-manager-basic">
      <div className="header-basic-project">
        <Link to="/" className="back-button-basic-project">← Back</Link>
        <h1>Project Manager</h1>
        <span className="version-badge-basic-project">Synoppy 1.0</span>
      </div>

      <div className="project-stats-basic">
        <div className="stat-card-basic">
          <h3>Total Tasks</h3>
          <div className="stat-value-basic">{totalTasks}</div>
        </div>
        <div className="stat-card-basic">
          <h3>Completed</h3>
          <div className="stat-value-basic">{completedTasks}</div>
        </div>
        <div className="stat-card-basic">
          <h3>Progress</h3>
          <div className="stat-value-basic">{Math.round((completedTasks / totalTasks) * 100)}%</div>
        </div>
      </div>

      <div className="tasks-section-basic">
        <h2>Tasks</h2>
        <div className="tasks-list-basic">
          {tasks.map(task => (
            <div key={task.id} className={`task-item-basic ${task.completed ? 'completed' : ''}`}>
              <div className="task-checkbox-basic">
                <input
                  type="checkbox"
                  checked={task.completed}
                  onChange={() => handleToggleComplete(task.id)}
                />
              </div>
              <div className="task-content-basic">
                <div className="task-title-basic">{task.title}</div>
                <div className="task-details-basic">
                  <span>Assignee: {task.assignee}</span>
                  <span>Due: {task.dueDate}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="upgrade-section-basic">
        <Link to="?version=1.5" className="upgrade-link-basic">
          Try Synoppy 1.5 Advanced Version →
        </Link>
      </div>
    </div>
  );
};

export default ProjectManagerBasic;